"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFeatureFlags = exports.FeatureFlagDispatcherContext = exports.FeatureFlagContext = void 0;
var _react = require("react");
var _cdsUtils = require("@cbhq/cds-utils");
// Feature Flag tokens
const defaultFeatureFlags = {
  /** Web only - Leverages the CSS flex 'gap' property instead of inserting extra DOM nodes.
   * @link https://developer.mozilla.org/en-US/docs/Web/CSS/gap
   */
  flexGap: false,
  /** Mobile only - Consumers can enable this flag if they are using the new Fabric renderer
   * @link https://reactnative.dev/architecture/fabric-renderer
   */
  fabric: false
};

// Feature Flag types
exports.defaultFeatureFlags = defaultFeatureFlags;
// Feature Flag contexts
const FeatureFlagContext = /*#__PURE__*/(0, _react.createContext)(defaultFeatureFlags);
exports.FeatureFlagContext = FeatureFlagContext;
const FeatureFlagDispatcherContext = /*#__PURE__*/(0, _react.createContext)({
  dispatch: _cdsUtils.noop
});
exports.FeatureFlagDispatcherContext = FeatureFlagDispatcherContext;